export const ASSET_BASE =
  'https://drwzpk38qkpfb.cloudfront.net/site8970-1.websiteforge.com/'

export const asset = (path: string): string => `${ASSET_BASE}${path}`

export const PHONE_DISPLAY = '517-545-7772'
export const PHONE_HREF = 'tel:+15175457772'

/* Company-wide toll-free line shown in the header only. Office-specific
   numbers stay on their own locations. */
export const TOLL_FREE_DISPLAY = '888-2-KOSINS'
export const TOLL_FREE_NUMERIC = '888-256-7467'
export const TOLL_FREE_HREF = 'tel:+18882567467'

export const PRIVACY_URL = 'https://www.kosinsglass.com/privacy-policy.html'

export const LINKS = {
  auto: 'https://www.kosinsglass.com/autoglass.html',
  windshield: 'https://www.kosinsglass.com/windshieldreplacement.html',
  chip: 'https://www.kosinsglass.com/Windshield-Chip-Repair',
  residential: 'https://www.kosinsglass.com/residentialglass.html',
  shower: 'https://www.kosinsglass.com/euroglasshowerdoors.html',
  commercial: 'https://www.kosinsglass.com/commercialglass.html',
  emergencyAuto:
    'https://www.kosinsglass.com/emergency-auto-glass-repair.html',
  adas: 'https://www.kosinsglass.com/ADAS-Calibration-On-Site',
  contact: 'https://www.kosinsglass.com/contact-kosins-glass.html',
  resources: 'https://www.kosinsglass.com/glass-resources-expert-guides',
}

export const IMAGES = {
  logo: asset('uploaded/images/logo.png'),
  heroWide:
    'https://cdn.magicpatterns.com/uploads/ozfyN5dn6P2v7GMmFX4KhE/kosins-working-vans-panorama.png',
  heroMobile:
    'https://cdn.magicpatterns.com/uploads/gW9xCdYLf3pNDJyf6BuWcY/kosins-working-vans-mobile.png',
  auto: asset('uploaded/images/NewDesign/Emergency_Auto.png'),
  residential: asset('uploaded/images/New%20Design/residential.jpg'),
  shower: asset('uploaded/images/NewDesign/GSDpic5.webp'),
  showerAlt: asset('uploaded/images/NewDesign/GSDpic1.webp'),
  commercial: asset('uploaded/images/NewDesign/comertialpic1.webp'),
  commercialAlt: asset('uploaded/images/NewDesign/commercialpic9.webp'),
}
